"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useId;

var _react = require("react");

var _AutoIdProvider = _interopRequireDefault(require("./AutoIdProvider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useId(customId) {
  var getId = (0, _react.useContext)(_AutoIdProvider["default"].Context);

  var _useState = (0, _react.useState)(getId),
      _useState2 = _slicedToArray(_useState, 1),
      autoId = _useState2[0];

  return customId || autoId;
}